/* @flow */

import { createBrowserHistory } from 'history';
import config from './config';

var history = createBrowserHistory({
  basename: config.BASE_PATH
});

export { history };
